import { PRIVATE_HTTP as http } from "../http-common";

const currentAssistance = async () => {
  return http().get(`/api/v4/assistances/current`);
};

const createAssistanceAPI = async (body: any) => {
  return http().post(`/api/v4/assistances`, body);
};

const cancelAssistanceAPI = async (id: number) => {
  return http().get(`/api/v4/assistances/${id}/cancel`);
};

const assistanceStatusAPI = async (id: number) => {
  return http().get(`/api/v4/assistances/${id}/status`);
};

const getAllAssistances = async () => {
  return http().get(`/api/v4/assistances`);
};

export {
  currentAssistance,
  createAssistanceAPI,
  cancelAssistanceAPI,
  assistanceStatusAPI,
  getAllAssistances,
};
